/**
 * Data Recovery Legal Case
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DataRecoveryLegalCaseState = {
  legalCases: {},
}

export const DataRecoveryLegalCaseActions = {
  fetchLegalCases: async ({ commit }, requestData) => {
    commit('setSearchLoading', true)

    return axiosRequest.
      get('/data_recovery/legal_cases', { params: requestData.params }).
      then(({ data }) => {
        commit('setLegalCases', data.legal_cases || {})
        commit('setSearchLoading', false)
      }).
      catch(handleError)
  },

  restoreLegalCaseToRecord: async (_, requestData) => {
    return axiosRequest.
      post(`/data_recovery/legal_cases/${requestData.id}/restore`, { legal_case: { id: requestData.id } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const DataRecoveryLegalCaseMutations = {
  setLegalCases: (state, payload) => {
    state.dataRecovery.legalCases = payload
  },
}

export const DataRecoveryLegalCaseGetters = {
  legalCases: state => state.dataRecovery.legalCases,
}
